export default {"src":"/_next/static/media/icon-everlane.b6015d26.svg","height":75,"width":75};